// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperUserActions_container__5RYHE{
    width: calc(100% - 50px);
    padding: 22px 24px;
    background-color: #FFF6E9;
    border: 1px solid #FFDFB0;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
@media(max-width: 600px){
    .SuperUserActions_container__5RYHE{
        padding: 22px 25px;
    }
}
.SuperUserActions_endFundraiserButton__WSdLw, .SuperUserActions_requestDonationsReportButton__L7Hlx{
    height: 38px;
    width: 100%
}
.SuperUserActions_requestDonationsReportButton__L7Hlx{
    color: #EB443F;
    background-color: #FFF6E9;
    border-color: #EB443F66;
}
.SuperUserActions_requestDonationsReportButton__L7Hlx:not(:first-child){
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/SuperUserActions.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,YAAY;IACZ;AACJ;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".container{\n    width: calc(100% - 50px);\n    padding: 22px 24px;\n    background-color: #FFF6E9;\n    border: 1px solid #FFDFB0;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n@media(max-width: 600px){\n    .container{\n        padding: 22px 25px;\n    }\n}\n.endFundraiserButton, .requestDonationsReportButton{\n    height: 38px;\n    width: 100%\n}\n.requestDonationsReportButton{\n    color: #EB443F;\n    background-color: #FFF6E9;\n    border-color: #EB443F66;\n}\n.requestDonationsReportButton:not(:first-child){\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SuperUserActions_container__5RYHE`,
	"endFundraiserButton": `SuperUserActions_endFundraiserButton__WSdLw`,
	"requestDonationsReportButton": `SuperUserActions_requestDonationsReportButton__L7Hlx`
};
export default ___CSS_LOADER_EXPORT___;
